/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setProtocolOptions } from '../store/options.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getProtocolOptions() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const protocolMethodsResponse = yield call([vitalsService, vitalsService.getProtocolMethod])
    const { entity } = protocolMethodsResponse
    yield put(setProtocolOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getProtocolOptions() error: ${e}`))
  }
}

export function* getProtocolOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getProtocolOptions)
}
